import styled from "styled-components";
import colors from "css/colors";

export const TableWrapper = styled.table``;

export const TableBody = styled.tbody`
  display: flex;
  border: 1px solid ${colors.GREY_LIGHT};
  border-radius: 4px;
`;

export const Column = styled.tr`
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    border-right: 1px solid ${colors.GREY_LIGHT};
  }
`;

export const HeaderCell = styled.th`
  display: flex;
  align-items: center;
  padding: 16px;
  height: 70px;
  width: 200px;

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.GREY_LIGHT};
  }
`;

export const HeaderText = styled.div`
  font-size: 12px;
  font-weight: 600;
`;

interface CellProps {
  color?: string;
}

export const Cell = styled.td<CellProps>`
  display: flex;
  align-items: center;
  padding: 16px;
  height: 70px;
  width: 132px;
  color: ${(props) => (props.color ? props.color : colors.CHARCOAL)};
  font-size: 12px;
  font-weight: 600;
  overflow: auto;

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.GREY_LIGHT};
  }
`;
